// extracted by mini-css-extract-plugin
module.exports = {"templateContainer":"template1_templateContainer__W6rbB"};